// extracted by mini-css-extract-plugin
export default {"languageProfile":"language_profile_languageProfile__+LyB9"};